module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/antiBacterial@3x_ae3ab0.png";